import { Box, Button, Flex, HStack, Stack, Text } from '@chakra-ui/react'
import { useDaily, useDevices } from '@daily-co/daily-react'
import { trackEvent } from '@lib/clinician-tracking'
import React, { useEffect, useState } from 'react'
import { BlueNavLogo } from '../../../../images/brand/blue-nav-logo'
import { CallSetup } from './components/call-setup'
import { TestAudioButton } from './components/test-audio-button'
import { useClinicianDailyManager } from './context/clinician-daily-manager.context'
export const ClinicianWaitingRoom = () => {
  const [promptForPermissions, setPromptForPermissions] = useState(false)
  const [isPromptingLoading, setIsPromptingLoading] = useState(false)
  const { joinCall } = useClinicianDailyManager()
  const daily = useDaily()
  const devices = useDevices()
  const handleStartSession = async () => {
    await joinCall()
    trackEvent('click:telehealth-session.clinician-start-session')
  }

  const handlePromptPermissions = () => {
    daily?.startCamera()
    setIsPromptingLoading(true)
    setTimeout(() => {
      // wait a second for native prompt to appear
      setPromptForPermissions(false)
      setIsPromptingLoading(false)
    }, 1300)
  }

  useEffect(() => {
    if (daily) {
      daily?.enumerateDevices().then(devices => {
        if (devices.devices.filter(d => !!d.deviceId).length === 0) {
          setPromptForPermissions(true)
        } else {
          daily.startCamera()
        }
      })
    }
  }, [daily])

  const actionBar = (
    <Stack
      w="100%"
      alignItems="flex-start"
      direction={{ base: 'column', sm: 'row' }}
      gap={{ base: '4px', sm: '8px' }}
    >
      {promptForPermissions ? (
        <Button
          onClick={handlePromptPermissions}
          isFullWidth
          _focus={{ outline: 'none' }}
          size="lg"
          mx="0px"
          isLoading={isPromptingLoading}
          data-click-text="Allow access"
        >
          Allow access
        </Button>
      ) : (
        <HStack w="100%" gap="8px">
          <TestAudioButton
            currentDevice={devices.currentSpeaker?.device.deviceId || 'default'}
          />
          <Button
            w="100%"
            maxW="50%"
            onClick={handleStartSession}
            size="lg"
            data-click-text="I'm all set"
          >
            I'm all set
          </Button>
        </HStack>
      )}
    </Stack>
  )

  return (
    <Flex
      pt={{ base: '9px', md: '60px' }}
      w="100%"
      h="100%"
      justify="center"
      align="center"
      direction="column"
    >
      <BlueNavLogo display={{ base: 'block', md: 'none' }} mb="21px" />
      <Box pt="4px" w="100%" h="100%">
        <Box mb="medium">
          <Text align="center" fontSize="24px" fontWeight="430">
            {promptForPermissions
              ? 'Enable your camera and mic'
              : 'Check your camera and mic'}
          </Text>
        </Box>
        <CallSetup
          bottomActionBar={actionBar}
          maskInputs={promptForPermissions}
          padding="small"
        />
      </Box>
    </Flex>
  )
}
